<template>
  <div class="content-registrationprocess">
    <div class="grid-container">
      <div class="inner">
        <h2 v-if="data.title" class="title" v-html="data.title" />
        <ol class="step-item-wrapper">
          <StepItem v-for="(step, index) in data.steps" :key="step.id" :step="step" :index="index" />
        </ol>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentRegistrationprocessFragment } from '#gql';
import StepItem from '~/components/content-modules/components/StepItem.vue';

defineProps<{
  data: ContentRegistrationprocessFragment;
}>();
</script>

<style scoped lang="scss">
.content-registrationprocess {
  background-color: var(--color-main-blue-light);
  color: var(--color-main-blue);
  width: 100%;

  @media (--xs), (--sm) {
    margin: var(--spacing-sm) 0;
    padding: var(--spacing-2xl) 0;
  }

  @media (--md), (--lg) {
    margin: var(--spacing-2xl) 0;
    padding: var(--spacing-4xl) 0;
  }

  > .grid-container {
    @include grid-layout();

    & {
      padding: var(--site-inner-padding);
      width: 100%;
      max-width: var(--site-max-width);
      margin: auto;
    }

    > .inner {
      @media (--xs) {
        grid-column: 1 / -1;
      }

      @media (--sm) {
        grid-column: 2 / 24;
      }

      @media (--md), (--lg) {
        grid-column: 5 / 21;
      }

      > .title {
        margin-bottom: var(--spacing-md);
      }

      > .step-item-wrapper {
        display: grid;
        gap: var(--spacing-sm);
        padding: 0;
      }
    }
  }
}
</style>
